// common javascript functionality
// @codekit-prepend "dev/js/main-common.js"

// elementor related javascript
// @codekit-prepend "dev/js/main-elementor.js"

(function( $ ) {

    // ----------------- //
    // main-elementor.js
    //

    // only evoke plugin elementorMainBeau3 if necessary
    if(
        beau3_variables.elementor.adjustMarginInnerSection ||
        beau3_variables.elementor.adjustMarginSectionWithBackground ||
        beau3_variables.elementor.adjustMarginColumnWithBackground ||
        beau3_variables.elementor.adjustMarginTexteditorWithBackground
    ) {
        var opts = {
            // adjusts inner section margin to fit content
            adjustMarginInnerSection: beau3_variables.elementor.adjustMarginInnerSection,
            // adjusts outer margin of outer section with background
            adjustMarginSectionWithBackground: beau3_variables.elementor.adjustMarginSectionWithBackground,
            // adjusts outer margin of column with background
            adjustMarginColumnWithBackground: beau3_variables.elementor.adjustMarginColumnWithBackground,
            // add padding on texteditor with background color
            adjustMarginTexteditorWithBackground: beau3_variables.elementor.adjustMarginTexteditorWithBackground
        };

        // init plugin outside plugin so it can be overwritten
        $(".elementor").elementorMainBeau3(opts);
    }
    // ----------------- //
}(jQuery));



// background image handler
// @codekit-prepend "dev/js/main-background-image.js"
